import axiosPost from "../axiosPost";

export const horarioDel = async ({
    gateHorarioId = null,
}, credentials) => {
    const body = {
        service: "GateHorarioDel",
        params: {
            gateHorarioId,
        },
    };

    return await axiosPost(body, credentials);
};
